import React, { useState } from "react";
import { toast } from "sonner";
import { Timer, Download, Sparkles } from "lucide-react";

const BIDS = [
  { id: "BR-9012", spec: "Business cards, 500 qty, matt lamination", location: "Nehru Place", timeLeft: "01:32:22", desired: 2500 },
  { id: "BR-9013", spec: "A3 Flyers × 1000, glossy", location: "Saket", timeLeft: "00:41:05", desired: 6000 },
  { id: "BR-9014", spec: "Product packaging box × 250", location: "Gurugram", timeLeft: "02:11:44", desired: 8000 },
];

export default function VendorBidding() {
  const [prices, setPrices] = useState({});
  const [notes, setNotes] = useState({});
  const [submitted, setSubmitted] = useState({});

  const submit = (id) => {
    const p = Number(prices[id]);
    if (!p || p < 100) { toast.error("Enter a valid price"); return; }
    setSubmitted((s) => ({ ...s, [id]: p }));
    toast.success(`Bid submitted for ${id}`);
  };

  return (
    <div data-testid="vendor-bidding">
      <h1 className="font-display text-3xl font-bold">Live Bidding Inbox</h1>
      <p className="mt-1 text-sm text-neutral-600">Nearby customers looking for quotes. Submit before the timer runs out.</p>

      <div className="mt-4 space-y-3">
        {BIDS.map((b) => (
          <div key={b.id} className="rounded-lg border border-neutral-200 bg-white p-5" data-testid={`bid-${b.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-mono text-xs text-neutral-500">{b.id} · {b.location}</div>
                <div className="mt-1 font-display text-lg font-bold">{b.spec}</div>
                <div className="text-xs text-neutral-500">Customer's target: around ₹{b.desired.toLocaleString("en-IN")}</div>
              </div>
              <div className="inline-flex items-center gap-1 rounded-full border border-neutral-900 bg-lime-100 px-3 py-1 text-xs font-mono font-bold"><Timer size={12} /> {b.timeLeft}</div>
            </div>

            {submitted[b.id] ? (
              <div className="mt-4 rounded-md border border-lime-300 bg-lime-50 p-3 text-sm text-lime-800" data-testid={`bid-sent-${b.id}`}>
                <Sparkles size={14} className="mr-1 inline" /> Bid submitted at ₹{submitted[b.id].toLocaleString("en-IN")}. You'll be notified if the customer selects you.
              </div>
            ) : (
              <div className="mt-4 grid gap-3 md:grid-cols-3">
                <div>
                  <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">Your price (₹)</label>
                  <input type="number" value={prices[b.id] || ""} onChange={(e) => setPrices({ ...prices, [b.id]: e.target.value })} className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm" placeholder="e.g. 2400" data-testid={`bid-price-${b.id}`} />
                </div>
                <div className="md:col-span-2">
                  <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">Note to customer (optional)</label>
                  <input value={notes[b.id] || ""} onChange={(e) => setNotes({ ...notes, [b.id]: e.target.value })} className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm" placeholder="Ready in 6 hours…" data-testid={`bid-note-${b.id}`} />
                </div>
              </div>
            )}
            <div className="mt-3 flex flex-wrap gap-2">
              <button onClick={() => submit(b.id)} disabled={!!submitted[b.id]} className="rounded-md bg-neutral-950 px-3 py-2 text-xs font-bold text-white hover:bg-neutral-800 disabled:opacity-50" data-testid={`bid-submit-${b.id}`}>Submit bid</button>
              <button className="inline-flex items-center gap-1 rounded-md border border-neutral-300 px-3 py-2 text-xs font-semibold hover:border-neutral-900" onClick={() => toast.info("File downloaded")}><Download size={12} /> View file</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
